import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const certifications = [
    {
      icon: "Shield",
      title: "FinCEN Registered",
      description: "Money Services Business",
      color: "var(--color-primary)"
    },
    {
      icon: "Lock",
      title: "SOC 2 Type II",
      description: "Security Certified",
      color: "var(--color-brand-trust)"
    },
    {
      icon: "FileCheck",
      title: "SEC Compliant",
      description: "Regulatory Standards",
      color: "var(--color-secondary)"
    },
    {
      icon: "Building",
      title: "FDIC Insured",
      description: "Up to $250,000",
      color: "var(--color-brand-primary)"
    },
    {
      icon: "ShieldCheck",
      title: "ISO 27001",
      description: "Information Security",
      color: "var(--color-success)"
    },
    {
      icon: "Award",
      title: "PCI DSS",
      description: "Payment Security",
      color: "var(--color-accent)"
    }
  ];

  const stats = [
    { value: "500K+", label: "Active Users", icon: "Users" },
    { value: "$2.5B+", label: "Total Traded", icon: "TrendingUp" },
    { value: "99.9%", label: "Uptime", icon: "Zap" },
    { value: "24/7", label: "Support", icon: "Headphones" }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-[var(--color-card)]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-4">
            Trusted & Certified Platform
          </h2>
          <p className="text-base md:text-lg text-[var(--color-muted-foreground)] max-w-3xl mx-auto">
            Your security is our priority. We maintain the highest standards of regulatory compliance and security certifications
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6 mb-12 md:mb-16">
          {certifications?.map((cert, index) => (
            <div 
              key={index}
              className="bg-[var(--color-background)] rounded-xl p-4 md:p-6 text-center border border-[var(--color-border)] hover:shadow-md transition-shadow duration-300"
            >
              <div 
                className="w-12 h-12 md:w-14 md:h-14 rounded-full flex items-center justify-center mx-auto mb-3"
                style={{ backgroundColor: `${cert?.color}15` }}
              >
                <Icon name={cert?.icon} size={24} color={cert?.color} />
              </div>
              <h3 className="text-sm md:text-base font-semibold text-[var(--color-foreground)] mb-1">
                {cert?.title}
              </h3>
              <p className="text-xs md:text-sm text-[var(--color-muted-foreground)]">
                {cert?.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[var(--color-primary)] to-[var(--color-brand-primary)] rounded-2xl p-6 md:p-8 lg:p-12">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {stats?.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="flex items-center justify-center mb-3">
                  <Icon name={stat?.icon} size={32} color="#FFFFFF" />
                </div>
                <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2">
                  {stat?.value}
                </p>
                <p className="text-sm md:text-base text-white/80">
                  {stat?.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 md:mt-16 text-center">
          <p className="text-sm md:text-base text-[var(--color-muted-foreground)] mb-4">
            Recognized by leading financial and technology publications
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 lg:gap-12">
            <div className="text-lg md:text-xl font-semibold text-[var(--color-muted-foreground)]">Forbes</div>
            <div className="text-lg md:text-xl font-semibold text-[var(--color-muted-foreground)]">TechCrunch</div>
            <div className="text-lg md:text-xl font-semibold text-[var(--color-muted-foreground)]">Bloomberg</div>
            <div className="text-lg md:text-xl font-semibold text-[var(--color-muted-foreground)]">WSJ</div>
            <div className="text-lg md:text-xl font-semibold text-[var(--color-muted-foreground)]">CNBC</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;